import React, { useState, useCallback } from "react";
import api from "../../services/api";

const getInitials = (name) =>
  name ? name.split(" ").map((n) => n[0]).join("").toUpperCase().substring(0, 2) : "?";

const ContactAvatar = ({ src, alt, className, fallbackClassName, size = "md", contactId }) => {
  const [hasError, setHasError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src);
  const [hasRefreshed, setHasRefreshed] = useState(false);

  const handleError = useCallback(async () => {
    if (hasRefreshed || !contactId) {
      setHasError(true);
      return;
    }

    setHasRefreshed(true);

    try {
      const { data } = await api.post(`/contacts/${contactId}/refresh-profile-pic`);
      if (data.profilePicUrl && data.profilePicUrl !== currentSrc) {
        setCurrentSrc(data.profilePicUrl);
        return;
      }
    } catch {
      // Silently ignore refresh errors
    }

    setHasError(true);
  }, [hasRefreshed, contactId, currentSrc]);

  if (!currentSrc || hasError) {
    return (
      <div
        className={
          fallbackClassName ||
          "rounded-full bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300 flex items-center justify-center font-semibold"
        }
        style={{
          width: size === "sm" ? "2.25rem" : size === "lg" ? "6rem" : "2.5rem",
          height: size === "sm" ? "2.25rem" : size === "lg" ? "6rem" : "2.5rem",
          fontSize: size === "sm" ? "0.75rem" : size === "lg" ? "1.5rem" : "0.875rem",
        }}
      >
        {getInitials(alt)}
      </div>
    );
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className || "rounded-full object-cover"}
      style={{
        width: size === "sm" ? "2.25rem" : size === "lg" ? "6rem" : "2.5rem",
        height: size === "sm" ? "2.25rem" : size === "lg" ? "6rem" : "2.5rem",
      }}
      onError={handleError}
    />
  );
};

export default ContactAvatar;
